





















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TargetLine extends Vue {
  @Prop() test!: string;
  @Prop() x1!: number;
  @Prop() y1!: number;
  @Prop() x2!: number;
  @Prop() y2!: number;
  @Prop() strokeColor!: 'red' | 'white' | 'black' | 'purple' | 'green';

  public lineWidth = 5;
  public padding = 50;
  public randomMax = 100;

  get top() {
    return Math.floor(Math.random() * this.randomMax) - this.randomMax/2;
  }

  get left() {
    return Math.floor(Math.random() * this.randomMax) - this.randomMax/2;
  }

  get pathX1() {
    return Math.abs(this.x2 - this.x1) + this.padding/2 + Math.abs(this.left) + this.left
  }

  get pathY1() {
    return Math.abs(this.y2 - this.y1) + this.padding/2 + Math.abs(this.top) + this.top
  }

  get pathX2() {
    return Math.abs(this.x2 - this.x1) + this.padding/2 + this.randomMax/2 + (this.x2 - this.x1)
  }

  get pathY2() {
    return Math.abs(this.y2 - this.y1) + this.padding/2 + this.randomMax/2 + (this.y2 - this.y1)
  }

}
